<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-sticky
      :position="videoPosition"
      class="z-max q-ma-sm"
      style="overflow:visible;"
    >
      <q-card class="q-pa-xs bg-grey-2">
        <div
          class="z-max"
          style="position: absolute; top: 0; right: 24px; transform: translateY(-50%);"
        >
          <q-fab
            icon="keyboard_arrow_up"
            color="white"
            text-color="dark"
            :direction="fabDirection"
            padding="xs"
          >
            <!--
            <q-fab-action
              v-if="!$q.screen.lt.sm"
              :icon="switchHorizontalIcon"
              padding="xs"
              color="primary"
              text-color="white"
              @click="onSwitchHorizontalPosition"
            />
            -->
            <q-fab-action
              :icon="switchVerticalIcon"
              padding="xs"
              color="primary"
              text-color="white"
              @click="onSwitchVerticalPosition"
            />
            <q-fab-action
              icon="close_fullscreen"
              padding="xs"
              color="white"
              text-color="dark"
              @click="onCloseVideoPlayer"
            />
          </q-fab>
        </div>
        <!--
          style="height:36vh;"
          -->
        <div
          class="session-video-wrapper"
          :class="aspectRatioClass"
        >
          <video
            ref="videoPlayer"
            crossorigin="anonymous"
            class="video-js"
            :class="aspectRatioClass"
            @playing="onPlaying"
            @ended="onEnded"
            @pause="onPause"
            @durationchange="onDurationChange"
          />
        </div>
      </q-card>
    </q-page-sticky>
  </q-layout>
</template>
<script>
import 'video.js/dist/video-js.css';

import { get } from 'lodash';
import videojs from 'video.js';

export default {
  name: 'SessionVideo',

  props: {
    videoPlayerInfo: {
      type: Object,
      required: true,
    },
  },

  emits: ['update-time', 'close', 'ready'],

  data() {
    return {
      player: null,
      videoDuration: null,

      playbackTimer: null,

      videoPlayerOptions: null,

      videoAspectRatio: '16:9',
      // videoAspectRatio: '9:16',
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
    };
  },

  computed: {

    switchHorizontalIcon() {
      return this.horizontalPosition === 'left' ? 'align_horizontal_right' : 'align_horizontal_left';
    },

    switchVerticalIcon() {
      return this.verticalPosition === 'top' ? 'align_vertical_bottom' : 'align_vertical_top';
    },

    videoPosition() {
      return `${this.verticalPosition}-${this.horizontalPosition}`;
    },

    fabDirection() {
      if (this.videoAspectRatio === '9:16') {
        return (this.horizontalPosition === 'right') ? 'left' : 'right';
      }
      return (this.verticalPosition === 'bottom') ? 'up' : 'down';
    },

    aspectRatioClass() {
      return (this.videoAspectRatio === '9:16') ? 'vjs-9-16' : 'vjs-16-9';
    },

  },

  watch: {
    videoPlayerInfo: {
      deep: true,
      immediate: false,
      handler() {
        this.playVideo();
      },
    },
  },

  mounted() {
    this.playVideo();
  },

  beforeUnmount() {
    this.stopPlaybackTimer();
    this.player.dispose();
  }, // beforeUnmount()

  methods: {
    setCurrentTime(timestamp) {
      if (this.player) {
        this.player.currentTime(timestamp);
      }
    }, // setCurrentTime()

    onPlaying() {
      this.stopPlaybackTimer();
      this.playbackTimer = setInterval(() => {
        if (!this.player) {
          this.stopPlaybackTimer();
        }
        const sessionTimeOffset = get(this.videoPlayerInfo, 'sessionTimeOffset', 0);
        this.$emit('update-time', this.player.currentTime() + sessionTimeOffset);
      }, 100);
    }, // onPlaying()

    onEnded() {
      this.stopPlaybackTimer();
    }, // onEnded()

    onPause() {
      this.stopPlaybackTimer();
    }, // onPause()

    onDurationChange() {
      this.videoDuration = this.player.duration();
    }, // onDurationChange()

    onSwitchHorizontalPosition() {
      this.horizontalPosition = this.horizontalPosition === 'right' ? 'left' : 'right';
    },

    onSwitchVerticalPosition() {
      this.verticalPosition = this.verticalPosition === 'top' ? 'bottom' : 'top';
    },

    onCloseVideoPlayer() {
      this.$emit('close');
    },

    stopPlaybackTimer() {
      if (this.playbackTimer !== null) {
        clearInterval(this.playbackTimer);
        this.playbackTimer = null;
      }
    },

    async playVideo() {
      this.videoPlayerOptions = {
        autoplay: true,
        controls: true,
        playsinline: true,
        // aspectRatio: this.videoAspectRatio,
        sources: [
          {
            src: get(this.videoPlayerInfo, 'src'),
            type: get(this.videoPlayerInfo, 'type'),
          },
        ],
      };

      if (!this.player) {
        this.player = videojs(this.$refs.videoPlayer, this.videoPlayerOptions, () => {
          this.$emit('ready');
        });
        return;
      }
      if (!this.player.paused) {
        this.player.pause();
      }

      await this.player.src(this.videoPlayerOptions.sources);
      await this.player.load();
      this.player.play();
    }, // playVideo()

    getCurrentTime() {
      return this.player.currentTime();
    }, // getCurrentTime()

    getDuration() {
      return this.player.duration();
    }, // getDuration()
  },
};
</script>
<style scoped>
.video-js.vjs-16-9:not(.vjs-fullscreen) {
  height: inherit;
  width: 64vh;
  max-width: 95vw;
}

.video-js.vjs-9-16:not(.vjs-fullscreen) {
  height: inherit;
  width: 34vh;
  max-width: 95vw;
}

.session-video-wrapper.vjs-16-9 {
  height: 36vh;
}

.session-video-wrapper.vjs-9-16 {
  height: 60vh;
}
</style>
